export default __webpack_public_path__ + "static/media/GothamBook.58fb9151.ttf";